const bankAccountErrorMapper: Record<string, string> = {
  'Bank Account Info with this Bank account number already exists.':
    'این شماره حساب بانکی قبلاً ثبت شده است.',

  'Bank Account Info with this IBAN number already exists.':
    'این شماره شبا قبلاً ثبت شده است.',
};

export const convertErrorsToPersian = (errors: string[]): string[] =>
  errors.map(error => bankAccountErrorMapper[error] ?? error);
